import React from 'react'

export const DocActionContext = React.createContext({
  isReadOnly: false,
  useValidationFromContext: false,
})
